import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { faqTypeSchema, moduleSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";

const AddModule = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    name: editData?.name || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? true,
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: moduleSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId ? await axiosInstance.put(`/module/update/${editingId}`, values)
          : await axiosInstance.post("/module/create", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/modules");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Modules", path: "/modules" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Module
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="module-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="module-sortOrder"
                        name="sortOrder"
                        placeholder="Enter module Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="faq-type-name" className="col-form-label">
                        Name
                      </label>

                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="module-name"
                        name="name"
                        placeholder="Enter module name"
                        value={values.name || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      {touched.name && errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/modules">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddModule;
